import { render, staticRenderFns } from "./ReUploadServeData.vue?vue&type=template&id=450a7a06&scoped=true&"
import script from "./ReUploadServeData.vue?vue&type=script&lang=js&"
export * from "./ReUploadServeData.vue?vue&type=script&lang=js&"
import style0 from "./ReUploadServeData.vue?vue&type=style&index=0&id=450a7a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a7a06",
  null
  
)

export default component.exports